export const partnerSlideSetting = {
	dots: false,
	infinite: true,
	speed: 2000,
	autoplay: true,
	autoplaySpeed: 3000,
	slidesToShow: 5,
	slidesToScroll: 3,
	className: 'text-center',
	responsive: [
		{
			breakpoint: 1024,
			settings: {
				slidesToShow: 5,
				slidesToScroll: 3,
			},
		},
		{
			breakpoint: 600,
			settings: {
				slidesToShow: 2,
				slidesToScroll: 2,
			},
		},
		{
			breakpoint: 480,
			settings: {
				slidesToShow: 2,
				slidesToScroll: 1,
			},
		},
	],
};
